import { render, staticRenderFns } from "./ProjectsStats.vue?vue&type=template&id=40f9cba4"
import script from "./ProjectsStats.vue?vue&type=script&lang=ts"
export * from "./ProjectsStats.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsStats.vue?vue&type=style&index=0&id=40f9cba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports